module.exports = __webpack_public_path__ + "static/media/PhotographyWithCompanion.909f8033.svg";